import React from 'react';
import styles from '../../styles/MateriasEquivalentesStyles/MateriasEquivalentes.module.css';

/**
 * Tarjeta read-only con datos del estudiante seleccionado.
 *
 * Props:
 *  - estudiante: payload devuelto por getEstudianteParaRevalidacion()
 */
function InfoEstudiante({ estudiante }) {
  if (!estudiante) return null;
  return (
    <div className={styles.studentCard}>
      <div className={styles.studentField}>
        <span className={styles.studentFieldLabel}>Matrícula</span>
        <span className={styles.studentFieldValue}>{estudiante.matricula || '—'}</span>
      </div>
      <div className={styles.studentField}>
        <span className={styles.studentFieldLabel}>Nombre completo</span>
        <span className={styles.studentFieldValue}>{estudiante.nombre_completo || '—'}</span>
      </div>
      <div className={styles.studentField}>
        <span className={styles.studentFieldLabel}>Programa</span>
        <span className={styles.studentFieldValue}>{estudiante.programa_nombre || '—'}</span>
      </div>
      <div className={styles.studentField}>
        <span className={styles.studentFieldLabel}>Sección</span>
        <span className={styles.studentFieldValue}>{estudiante.seccion_nombre || '—'}</span>
      </div>
      <div className={styles.studentField}>
        <span className={styles.studentFieldLabel}>Campus</span>
        <span className={styles.studentFieldValue}>{estudiante.campus_nombre || '—'}</span>
      </div>
      <div className={styles.studentField}>
        <span className={styles.studentFieldLabel}>Estatus</span>
        <span className={styles.studentFieldValue}>{estudiante.estatus_estudiante || '—'}</span>
      </div>
    </div>
  );
}

export default InfoEstudiante;
